export default __webpack_public_path__ + "static/media/heart.7d1a9769.svg";